import React from 'react';
import styles from './CallBanner.module.css';
import { ReactComponent as Phone } from '../../../assets/images/Vendor/NJR/phone.svg';
import { stripPhoneNumber } from '../../shared/util.js';

const CallBanner = ({ phoneNumber }) => (
    <div className={styles.helpContact}>
        <div className={styles.helpContactContent}>
            <div className={styles.serviceIcon}>
                <Phone />
            </div>
            <div className={styles.helpPhoneText}>
                <div>Need Help?</div>
                <div>
                    Call{' '}
                    <a
                        href={`tel:${stripPhoneNumber(phoneNumber)}`}
                        aria-label='Customer service phone number'
                        className=' font-weight-bold callLink'
                    >
                        {phoneNumber}
                    </a>
                </div>
            </div>
        </div>
    </div>
);

export default CallBanner;
